import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Badge } from "../badge/Badge";
import { IdBadgePosition } from "../badge/IdBadgePosition";
import { Icon } from "../icon/Icon";
export var HudStatBar = function (_a) {
    var icon = _a.icon, styleId = _a.styleId, className = _a.className, backgroundClassName = _a.backgroundClassName, backgroundSize = _a.backgroundSize, children = _a.children, fillClass = _a.fillClass;
    var size = backgroundSize ? "-" + backgroundSize : "";
    var background = backgroundClassName
        ? backgroundClassName + "-background" + size + " " + backgroundClassName + "-background"
        : IdStyles.StatBackground;
    return (React.createElement("div", { className: className + " " + background },
        React.createElement("div", { className: fillClass + " flex flex--guts" },
            React.createElement("div", { className: IdStyles.TextBoldAccent }, children),
            React.createElement(Badge, { position: IdBadgePosition.Left },
                React.createElement(Icon, { icon: icon, styleId: styleId })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/hud-stat-bar/HudStatBar.tsx
// module id = 590
// module chunks = 3